import { render, staticRenderFns } from "./PackageStore.vue?vue&type=template&id=a54acbd8&scoped=true"
import script from "./PackageStore.vue?vue&type=script&lang=js"
export * from "./PackageStore.vue?vue&type=script&lang=js"
import style0 from "./PackageStore.vue?vue&type=style&index=0&id=a54acbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54acbd8",
  null
  
)

export default component.exports